import { render, staticRenderFns } from "./ClientUpdate.vue?vue&type=template&id=5cdff1d6&scoped=true&"
import script from "./ClientUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ClientUpdate.vue?vue&type=style&index=0&id=5cdff1d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdff1d6",
  null
  
)

export default component.exports